import { uuidv4 } from '@/utils/util';
import { getProps } from './helper';
import dialogStore from './miniStore';

const { commit, dispatch } = dialogStore;

// loading
export const showLoading = () => {
  const id = uuidv4();
  commit.addLoading(id);
  return () => commit.removeLoading(id);
};
export const hideLoading = () => commit.hideLoading();

// alert
export const alert = options => {
  hideLoading();
  return dispatch.popup({ ...getProps(options), type: 'alert' });
};

export const confirm = message => {
  hideLoading();
  return dispatch.popup({
    ...getProps({ message, useCancel: true }),
    type: 'alert',
  });
};

/**
 * @typedef {Object} SnackbarOption
 * @property {String} message
 * @property {number} duration default 2500ms
 * @property {'warn'|'info'|'danger'} snackbarType default info
 */
/**
 *
 * @param {SnackbarOption|String} option
 */

export const snackbar = option => {
  dispatch.popup({ ...getProps(option), type: 'snackbar' });
};

export const snack = Object.freeze({
  warm: message => snackbar({ message, snackbarType: 'warn' }),
  info: message => snackbar({ message, snackbarType: 'info' }),
  danger: message => snackbar({ message, snackbarType: 'danger' }),
});

/**
 *
 * @param {String} message
 * @param {Function} work
 * @returns {Promise}
 */
export const addLongWork = (message, work) =>
  dispatch.addLongWork(message, work);
